import Vue from "vue/dist/vue";

/**
 * Select2 component
 */
Vue.component('select2', {
    props:     {
        options: {type: Array},
        value:   {},
        empty:   {default: undefined},
        name:    {default: undefined, type: String}
    },
    template:  '#select2-template',
    mounted:   function() {
        let vm = this;
        $(this.$el)
        // init select2
            .select2($.extend({data: this.options}, $(this.$el).data('plugin-options')))
            .val(this.value)
            .trigger('change')
            // emit event on change.
            .on('change', function() {
                // Update input model in VM using this component, use $(this).val() as it supports multiple selects
                vm.$emit('input', $(this).val())
            })
    },
    watch:     {
        value:   function(value) {
            // update value
            $(this.$el).val(value)
        },
        options: function(options) {
            // update options
            $(this.$el).empty().select2({data: options})
        }
    },
    destroyed: function() {
        $(this.$el).off().select2('destroy')
    }
});



// WEBPACK FOOTER //
// ./plugins/Admin/build/script/src/components/vue/select2.js